// extracted by mini-css-extract-plugin
module.exports = {"tags":"tags_tags__oGKuf","tags-item":"tags_tags-item__o08x3","tags-item-tag":"tags_tags-item-tag__bAPaG","tags-dots":"tags_tags-dots__XqpVt"};